import _ from 'lodash';

export class ScrollAnimation {

    constructor($el, config = {}) {
        this.$el = document.querySelector($el);
        this.init();
    }

    /*
        Initialize this mother lover
    */
    init() {
        if(this.$el) {
            this.animate(); //Set the opacity depending on our loaded scroll position
            this.initEventHandlers();
        }
    }

    /*
        Animate the element
    */
    animate() {
        this.$el.style.opacity = Math.min(Math.max(0, window.scrollY * 0.003), 1).toFixed(2);
    }

    /*
        Add required event listeners
    */
    initEventHandlers() {
        window.addEventListener('scroll', this.animate.bind(this));
        window.addEventListener('resize', this.animate.bind(this));
    }
}

export let animate = (el, opts) => new ScrollAnimation(el, opts);